import LinkedinIcon from '@/assets/svg/socials/linkedin.svg';
import XIcon from '@/assets/svg/socials/x-green.svg';
import YoutubeIcon from '@/assets/svg/socials/youtube.svg';
import { config } from '@/config';
import {
  GAMMA_PRIME_LINKEDIN_URL,
  GAMMA_PRIME_X_URL,
  GAMMA_PRIME_YOUTUBE_URL,
} from '@/shared/constants/social-links';

export const footerMenuLinks = [
  [
    { text: 'Home', href: config.marketingBaseUrl },
    { text: 'Careers', href: config.marketingBaseUrl + '/careers' },
    { text: 'About Us', href: config.marketingBaseUrl + '/about-us' },
  ],
  [
    { text: 'Privacy Policy', href: config.marketingBaseUrl + '/privacy-policy' },
    { text: 'Terms of Service', href: config.marketingBaseUrl + '/terms-of-service' },
  ],
];

export const footerSocialLinks = [
  { text: 'YouTube', icon: <YoutubeIcon />, href: GAMMA_PRIME_YOUTUBE_URL },
  { text: 'X', icon: <XIcon />, href: GAMMA_PRIME_X_URL },
  { text: 'LinkedIn', icon: <LinkedinIcon />, href: GAMMA_PRIME_LINKEDIN_URL },
];
